import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputSearch } from '@/pcomponents/common/date_picker/custom_input';
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import DatePicker from "react-datepicker";
import strFunc from '@/lib/lyg/string';

function SearchArea(props: any) {
  let myProps = {
    listOpt: {},
    list: (inData: any) => { },
    go_excel_down: () => { },
    ...props
  };
  let listOpt = myProps.listOpt;

  const on_search_change_input = (e: any) => {
    let { name, value } = e.target;
    let change_list_opt: any = {};
    change_list_opt[name] = value;
    myProps.list(change_list_opt);
  };

  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    myProps.list({
      now_page: "1",
      ...{ [key]: date_str }
    });
  };

  const goDateMonthChange = (sort: any) => {
    //next,pre
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let change_date_obj = new Date(selected_date);
    if (sort == "pre") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', -1);
    } else if (sort == "next") {
      change_date_obj = DateFunc.get_change_date(new Date(selected_date), 'month', +1);
    }

    let start_date = DateFunc.get_date_format(change_date_obj, "Y-m-01");
    let end_date = DateFunc.get_date_format(change_date_obj, "Y-m-t");
    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  const goChangeDateMonth = (month: number) => {
    let selected_date = listOpt.s_start_date;
    if (selected_date == "") {
      selected_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let row_year = selected_date.substring(0, 4);
    let row_month = strFunc.str_pad({ "str": month, "pad_length": 2 });
    selected_date = row_year + "-" + row_month + "-01";

    let start_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-01");
    let end_date = DateFunc.get_date_format(new Date(selected_date), "Y-m-t");
    myProps.list({
      now_page: "1",
      s_start_date: start_date,
      s_end_date: end_date,
    });
  };

  const change_start_end_date_by_sort = (sort: "this_year" | "this_month" | "pre_month") => {
    let now_month_init_date = DateFunc.get_date_format(new Date(), "Y-m-01");
    let s_start_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    let s_end_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    if (sort == "this_month") {
      s_start_date = DateFunc.get_date_format(new Date(), "Y-m-01");
      s_end_date = DateFunc.get_date_format(new Date(), "Y-m-t");
    } else if (sort == "pre_month") {
      s_start_date = DateFunc.get_date_format(new Date(DateFunc.get_change_date(new Date(now_month_init_date), 'month', -1)), "Y-m-01");
      s_end_date = DateFunc.get_date_format(new Date(DateFunc.get_change_date(new Date(now_month_init_date), 'month', -1)), "Y-m-t");
    } else if (sort == "this_year") {
      s_start_date = DateFunc.get_date_format(new Date(), "Y-01-01");
      s_end_date = "";
    }

    myProps.list({
      now_page: 1,
      s_start_date: s_start_date,
      s_end_date: s_end_date,
    });
  };

  let year_month_num_arr = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  return (
    <div className="my_flex_center">
      <span className="text-blue-700">
        {listOpt.s_start_date.substring(5, 7)} 월
      </span>
      {year_month_num_arr.map((row_num) => {
        let btn_class_name = "btn btn-dark ml-1";
        let select_month_num = parseInt(listOpt.s_start_date.substring(5, 7));
        if (select_month_num == row_num) {
          btn_class_name = "btn btn-blue ml-1";
        }
        return (
          <button key={row_num} className={btn_class_name}
            onClick={() => { goChangeDateMonth(row_num); }} >{row_num}</button>
        );
      })}
      <button className="btn btn-gray" onClick={() => { goDateMonthChange("pre"); }} >◀</button>
      <button className="btn btn-gray" onClick={() => { goDateMonthChange("next"); }} >▶</button>
      <button className="btn-s btn-dark ml-1"
        style={{ "background": "#0097BA" }}
        onClick={() => { change_start_end_date_by_sort("this_month"); }} >이번달</button>
      <button className="btn-s btn-dark ml-1"
        style={{ "background": "#0097BA" }}
        onClick={() => { change_start_end_date_by_sort("pre_month"); }} >지난달</button>
      <button className="btn-s btn-dark ml-1"
        style={{ "background": "#0097BA" }}
        onClick={() => { change_start_end_date_by_sort("this_year"); }} >올해</button>
      <span style={{ width: 100 }}>
        <DatePicker
          selected={listOpt.s_start_date != "" ? new Date(listOpt.s_start_date) : null}
          onChange={(date: Date) => {
            onChangeDatePicker("s_start_date", date);
          }}
          locale={ko}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInputSearch />}
          renderCustomHeader={customHeaderFunc}
        />
      </span>~
      <span style={{ width: 100 }}>
        <DatePicker
          selected={listOpt.s_end_date != "" ? new Date(listOpt.s_end_date) : null}
          onChange={(date: Date) => {
            onChangeDatePicker("s_end_date", date);
          }}
          locale={ko}
          dateFormat="yyyy-MM-dd"
          customInput={<CustomInputSearch />}
          renderCustomHeader={customHeaderFunc}
        />
      </span>

      <input type="text" className="search-input" name="s_user_name_like" value={listOpt.s_user_name_like}
        placeholder="이름"
        autoComplete='off'
        onChange={on_search_change_input} style={{ width: "80px" }} />
      <button className="btn btn-dark" onClick={() => { myProps.list({}); }} >검색</button>
      <button className='btn btn-sky' onClick={()=>{myProps.go_excel_down();}}>엑셀</button>
    </div>
  );
};
export default SearchArea;